import Alpine from "../alpine.js"
import { client } from "../client.js"

Alpine.data("workout", ({ workoutId, exercises }) => ({
  workoutId,
  exercises,
  workoutMode: false,
  currentExerciseIndex: 0,
  currentExercise: null,
  currentSide: 1,
  currentSet: 1,
  timer: null,
  timerInterval: null,
  timerEnd: null,
  videoPlaying: false,
  secondsLeft: 0,
  finished: false,
  startWorkout () {
    this.workoutMode = true
    this.currentExercise = this.exercises[this.currentExerciseIndex]
    this.startExercise()
  },
  startExercise () {
    this.videoPlaying = true
    let video = document.getElementById(`exercise_video_${this.currentExercise.id}`)
    if (video ) {
      video.play()
    }

    if (this.currentExercise.units === "seconds") {
      this.secondsLeft = this.currentExercise.quantity
    } else if (this.currentExercise.units === "minutes") {
      this.secondsLeft = parseInt(this.currentExercise.quantity * 60)
    }

    this.timerEnd = new Date((new Date().getTime() + this.secondsLeft * 1000))
    if (this.timer) { clearInterval(this.timer) }
    this.timer = setInterval(() => { this.tick() }, 250)
  },
  tick () {
    if (this.finished) {
      clearInterval(this.timer)
      return
    }

    let millisecondsLeft = (+this.timerEnd - new Date())

    if (millisecondsLeft > 1000) {
      this.secondsLeft = parseInt(millisecondsLeft/1000)
    } else {
      clearInterval(this.timer)
      this.next()
    }
  },
  next () {
    if (this.currentSide < this.currentExercise.sides) {
      this.currentSide = this.currentSide + 1
      this.startExercise()
    } else if (this.currentSet < this.currentExercise.sets) {
      if (this.currentExercise.circuit_number) {
        let nextExercise = this.exercises[this.currentExerciseIndex + 1]

        if (nextExercise && nextExercise.circuit_number === this.currentExercise.circuit_number) {
          // this next exercise is part of current circuit
          this.currentSide = 1
          this.currentExerciseIndex = this.currentExerciseIndex + 1
          this.currentExercise = nextExercise
          this.startExercise()
        } else {
          // we need to loop back to the beginning of the circuit exercised
          this.currentSide = 1
          this.currentSet = this.currentSet + 1

          for (let i = 0; i < this.exercises.length; i++) {
            this.currentExerciseIndex = i
            let exercise = this.exercises[i]
            if (exercise && exercise.circuit_number === this.currentExercise.circuit_number) {
              this.currentExercise = exercise
              this.startExercise()
              break
            }
          }
        }
      } else {
        this.currentSide = 1
        this.currentSet = this.currentSet + 1
        this.startExercise()
      }
    } else {
      let nextExercise = this.exercises[this.currentExerciseIndex + 1]

      if (nextExercise && nextExercise.circuit_number === this.currentExercise.circuit_number) {
        if (nextExercise.circuit_number && nextExercise.circuit_number !== this.currentExercise.circuit_number) {
          this.currentSet = 1
        }
        this.currentSide = 1
        this.currentExerciseIndex = this.currentExerciseIndex + 1
        this.currentExercise = nextExercise
        this.startExercise()
      } else {
        this.finish()
      }
    }
  },
  finish () {
    this.finished = true
    clearInterval(this.timer)
    this.secondsLeft = 0
    window.Utility.Fireworks.launch()
    setTimeout(() => { this.$refs.completeWorkoutButton.click() }, 3000)
  },
  nextExercise () {
    if (this.currentSide < this.currentExercise.sides) {
      this.currentSide = this.currentExercise.sides
    }

    this.next()
  },
  prevExercise () {
    if (this.timer) { clearInterval(this.timer) }

    if (this.currentExerciseIndex === 0 && this.currentSet > 1) {
      if (this.timer) { clearInterval(this.timer) }

      this.currentSide = 1
      this.currentSet = this.currentSet - 1
      this.currentExerciseIndex = this.exercises.length - 1
      this.currentExercise = this.exercises[this.currentExerciseIndex]
      this.startExercise()
    } else if (this.currentExerciseIndex === 0) {
      if (this.timer) { clearInterval(this.timer) }
      this.currentSide = 1
      this.currentExercise = this.exercises[this.currentExerciseIndex]
      this.startExercise()
    } else {
     if (this.timer) { clearInterval(this.timer) }

      this.currentSide = 1
      this.currentExerciseIndex = this.currentExerciseIndex - 1
      this.currentExercise = this.exercises[this.currentExerciseIndex]
      this.startExercise()
    }
  },
  resume () {
    this.videoPlaying = true

    let video = document.getElementById(`exercise_video_${this.currentExercise.id}`)
    if (video ) {
      video.play()
    }

    this.timerEnd = new Date((new Date().getTime() + this.secondsLeft * 1000))
    this.timer = setInterval(() => { this.tick() }, 250)
  },
  pause () {
    this.videoPlaying = false
    clearInterval(this.timer)

    let millisecondsLeft = (+this.timerEnd - new Date())
    this.secondsLeft = parseInt(millisecondsLeft/1000)

    let video = document.getElementById(`exercise_video_${this.currentExercise.id}`)
    if (video ) {
      video.pause()
    }
  }
}))
